import { PROCEDURE_IPDN_TREE_FILTER_URL, PROCEDURE_IPDN_TREE_URL, PROCEDURE_TREE_FILTER_URL, PROCEDURE_TREE_URL } from "../../common/CommonConstants";
import { toURL } from "../../reducers/util";
import {CONFIG} from "../../util/config";

const treeURL = PROCEDURE_TREE_URL
const searchURL = PROCEDURE_TREE_FILTER_URL
const treeIpdnUrl = PROCEDURE_IPDN_TREE_URL
const searchIpdnUrl = PROCEDURE_IPDN_TREE_FILTER_URL

export const searchForProcedures = (value: string, useIpdn: boolean = false) => {
    const host = useIpdn ? searchIpdnUrl : searchURL;
    const url = toURL(host + value, true);
    return doFetch(url);
}

export const getChildProceduresBlock = (key: string, useIpdn: boolean = false) => {
    const host = useIpdn ? treeIpdnUrl : treeURL;
    const url = toURL(`${host}?query=` + key, true);
    return doFetch(url);
}

const doFetch = (url: string) => {
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json',
      },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    .then(results => results.json())
}
